import InstallationContainer from './InstallationContainer';

export default InstallationContainer;
